import { isAnyOf } from '@reduxjs/toolkit';

import { archiveListing } from '../archiveListing';
import { changeDescription } from '../changeDescription';
import { changeHandle } from '../changeHandle';
import { changeProductCustomField } from '../changeProductCustomField';
import { changeVariantCustomField } from '../changeVariantCustomField';
import { createAndPublishListingFromMaster } from '../createAndPublishListingFromMaster';
import { createListingDraftFromPublished } from '../createListingDraftFromPublished';
import { createOption } from '../createOption';
import { createOptionValue } from '../createOptionValue';
import { createProductDraftFromLive } from '../createProductDraftFromLive';
import { createProductDraftFromMaster } from '../createProductDraftFromMaster';
import { createVariant } from '../createVariant';
import { createVariantDraftFromLive } from '../createVariantDraftFromLive';
import { createVariantDraftFromMaster } from '../createVariantDraftFromMaster';
import { deleteOption } from '../deleteOption';
import { deleteOptionValue } from '../deleteOptionValue';
import { deleteProductDraft } from '../deleteProductDraft';
import { deleteProductLiveSnapshot } from '../deleteProductLiveSnapshot';
import { deleteVariantLiveSnapshot } from '../deleteVariantLiveSnapshot';
import { discardProductDraft } from '../discardProductDraft';
import { getVariants } from '../getVariants';
import { getVariantsBulk } from '../getVariantsBulk';
import { publishProductDraft } from '../publishProductDraft';
import { publishSelectedVariantDrafts } from '../publishSelectedVariantDrafts';
import { pullProductFromMaster } from '../pullProductFromMaster';
import { remove } from '../remove';
import { removeMasterProduct } from '../removeMasterProduct';
import { removeMasterVariant } from '../removeMasterVariant';
import { removeProductLiveSnapshot } from '../removeProductLiveSnapshot';
import { removeVariantFromChannel } from '../removeVariantFromChannel';
import { removeVariantFromDraft } from '../removeVariantFromDraft';
import { removeVariantLiveSnapshot } from '../removeVariantLiveSnapshot';
import { rename } from '../rename';
import { revertVariantDraftToPublished } from '../revertVariantDraftToPublished';
import { updateListing } from '../updateListing';
import { updateListingVariant } from '../updateListingVariant';
import { updateMasterProduct } from '../updateMasterProduct';
import { updateMasterVariant } from '../updateMasterVariant';
import { BUSY_CONTEXT, clearBusyContext, setBusyContext } from './busyContext';

const FIELD_BUSY_THUNKS = [
  updateListing,
  updateListingVariant,
  updateMasterProduct,
  updateMasterVariant,
  changeProductCustomField,
  changeVariantCustomField,
  changeDescription,
  changeHandle,
  rename,
];

const ACTION_BUSY_THUNKS = [
  archiveListing,
  createAndPublishListingFromMaster,
  createListingDraftFromPublished,
  createOption,
  createOptionValue,
  createProductDraftFromLive,
  createProductDraftFromMaster,
  createVariant,
  createVariantDraftFromLive,
  createVariantDraftFromMaster,
  deleteOption,
  deleteOptionValue,
  deleteProductDraft,
  deleteProductLiveSnapshot,
  deleteVariantLiveSnapshot,
  discardProductDraft,
  getVariants,
  getVariantsBulk,
  publishProductDraft,
  publishSelectedVariantDrafts,
  pullProductFromMaster,
  remove,
  removeMasterProduct,
  removeMasterVariant,
  removeProductLiveSnapshot,
  removeVariantFromChannel,
  removeVariantFromDraft,
  removeVariantLiveSnapshot,
  revertVariantDraftToPublished,
];

const ALL_BUSY_THUNKS = [...FIELD_BUSY_THUNKS, ...ACTION_BUSY_THUNKS];

const toPendingMatchers = (thunks) => thunks.map((thunk) => thunk.pending);
const toSettledMatchers = (thunks) => thunks.flatMap((thunk) => [thunk.fulfilled, thunk.rejected]);

export const registerBusyContextReducers = (builder) => {
  builder
    .addMatcher(isAnyOf(...toPendingMatchers(FIELD_BUSY_THUNKS)), (state) => {
      setBusyContext(state, BUSY_CONTEXT.FIELDS);
    })
    .addMatcher(isAnyOf(...toPendingMatchers(ACTION_BUSY_THUNKS)), (state) => {
      setBusyContext(state, BUSY_CONTEXT.ACTION);
    })
    .addMatcher(isAnyOf(...toSettledMatchers(ALL_BUSY_THUNKS)), (state) => {
      clearBusyContext(state);
    });
};
